<!-- =========================================================================================
  File Name: FrequencyCreate.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div slot="no-body" class="tabs-container px-6">
		<div class="mb-2" style="border: 1px solid #e4e4e4; border-radius: 10px">
			<floating-buttons
				:titleHeader="$t('BreakTable.Action')"
				:saveText="$t('Save')"
				:disabledSave="!validateForm"
				:cancelText="$t('Cancel')"
				@save="submitForm"
				@cancel="$router.push({name: 'app-frequency-list'})"
			/>
		</div>
		<vs-navbar :type="'gradient'" v-model="activeNavItem" class="nabarx mb-2 cursor-pointer">
			<div slot="title">
				<vs-navbar-title>
					<span class="font-bold">{{ navbarTitle }}</span>
				</vs-navbar-title>
			</div>
			<vs-navbar-item :index="0">
				<div class="flex flex-col items-center justify-center p-2">
					<vs-icon icon="calendar_today" size="medium" class="cursor-pointer"></vs-icon>
					<small :class="activeNavItem === 0 ? 'font-bold text-white' : ''">
						{{ $t("TimeWindow.Schedule") }}
					</small>
				</div>
			</vs-navbar-item>
			<vs-navbar-item :index="1">
				<div class="flex flex-col items-center justify-center p-2">
					<vs-icon icon="location_on" size="medium" class="cursor-pointer"></vs-icon>
					<small :class="activeNavItem === 1 ? 'font-bold text-white' : ''">
						{{ $t("Routing.Title.VisitPoints") }}
					</small>
				</div>
			</vs-navbar-item>
			<vs-navbar-item :index="2">
				<div class="flex flex-col items-center justify-center p-2">
					<vs-icon icon="local_shipping" size="medium" class="cursor-pointer"></vs-icon>
					<small :class="activeNavItem === 2 ? 'font-bold text-white' : ''">
						{{ $t("Vehicles.Vehicles") }}
					</small>
				</div>
			</vs-navbar-item>
		</vs-navbar>
		<transition name="fade">
			<div v-show="activeNavItem === 0" id="user-edit-tab-info">
				<div class="vx-row">
					<div v-show="!maximize" class="vx-col md:w-1/2 sm:w-1/2 w-full">
						<vx-card :cardBorder="true" :noShadow="true">
							<form>
								<div class="vx-row">
									<div class="vx-col w-full">
										<vs-input
											class="w-full"
											v-model="frequencyData.name"
											v-validate="'required|max:150'"
											name="name"
											:label="$t('Routing.Table.Name')"
										/>
										<span class="text-danger text-sm" v-show="errors.has('name')">{{
											errors.first("name") !== undefined
												? $t(`VValidateMessage.${errors.first("name")}`)
												: ""
										}}</span>
									</div>
								</div>
								<div class="vx-row mt-2">
									<div class="vx-col w-full">
										<small class="flex items-center date-label cursor-pointer">
											{{ $t("TimeWindow.Duration") }}
											<i
												class="material-icons text-primary ml-1"
												style="font-size: 16px"
												:title="$t('DurationRefersToTheTotalTimeTaken')"
											>
												info
											</i>
										</small>
										<div class="flex flex-row justify-between">
											<vs-input-number
												v-model="hours"
												class="w-1/4 mr-4 cursor-pointer"
												name="duration"
												v-validate="'required'"
												:title="hours"
												:label="$t('RouterSelection.Hours')"
												:min="0"
											/>
											<vs-input-number
												v-model="minutes"
												class="w-full"
												name="duration"
												v-validate="'required'"
												:label="$t('RouterSelection.Minutes')"
												:min="0"
												:max="59"
												@keypress="validateInputNumberMinutes"
											/>
											<vs-input-number
												v-model="seconds"
												class="w-full ml-4"
												name="duration"
												v-validate="'required'"
												:label="$t('RouterSelection.Seconds')"
												:min="0"
												:max="59"
												@keypress="validateInputNumberSeconds"
											/>
										</div>
										<span class="text-danger text-sm" v-show="errors.has('duration')">{{
											$t("Routing.AssignColumns.Text1") +
											" " +
											$t("TimeWindow.Duration") +
											" " +
											$t("Routing.AssignColumns.Text2")
										}}</span>
									</div>
								</div>
								<div class="vx-row mt-2">
									<div class="vx-col w-full">
										<small>{{ $t("TimeWindow.Schedule") }}</small>
										<vx-card no-shadow card-border>
											<frequency-cron
												:duration="durationFrequency ? durationProps : '00:00:00'"
												:showDate="showDateFrequency"
											/>
										</vx-card>
									</div>
								</div>
								<div class="vx-row mt-2">
									<div class="vx-col w-full">
										<small>{{ $t("BreakTable.Description") }}</small>
										<vs-textarea
											name="description"
											type="text"
											class="w-full"
											v-model="frequencyData.description"
											v-validate="'max:150'"
										/>
										<span class="text-danger text-sm" v-show="errors.has('description')">{{
											errors.first("description") !== undefined
												? $t(`VValidateMessage.${errors.first("description")}`)
												: ""
										}}</span>
									</div>
								</div>
							</form>
						</vx-card>
					</div>
					<div class="vx-col" :class="maximize ? 'w-full' : 'md:w-1/2 sm:w-1/2 w-full'">
						<time-calendar
							ref="timeCalendar"
							:cronExpression="cronExpression"
							:duration="durationFrequency ? durationProps : '12:00:00'"
							@maximizeEmit="maximizeCalendar"
							@showDateEmit="getShowDate"
						/>
					</div>
				</div>
			</div>
		</transition>
		<transition name="fade">
			<div class="tab-text" v-show="activeNavItem === 1">
				<assigned-visit-point-list
					:isDemand="false"
					:isTypeService="false"
					:capacities="[]"
				></assigned-visit-point-list>
			</div>
		</transition>
		<transition name="fade">
			<div class="tab-text" v-show="activeNavItem === 2">
				<vehicle-assigned-list
					:isDemand="false"
					:capacities="[]"
					:search="true"
					:pagination="true"
				></vehicle-assigned-list>
			</div>
		</transition>
	</div>
</template>

<script>
import {FrequencyMixin} from "@/components/frequency/model/FrequencyMixin.js";

export default {
	mixins: [FrequencyMixin],
};
</script>
<style lang="scss" scoped>
.vs-navbar-gradient .vs-navbar-item-primary.is-active-item {
	border-radius: 6px;
	color: #fff !important;
	background: rgba(var(--vs-primary), 1);
}

.vs-navbar {
	-webkit-box-shadow: none;
	box-shadow: none;
}

.vs-navbar-gradient {
	border: 1px solid rgba(0, 0, 0, 0.05);
}

.vs-navbar-gradient .vs-navbar--item {
	border-left: 1px solid rgba(0, 0, 0, 0.05);
}
</style>
